import { useCallback, useEffect, useState } from "react";
import {
  RecordContextProvider,
  ResourceContextProvider,
  SimpleForm,
  Title,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import VacationRequest from "../../Requests/components/vacation/VacationRequest";
import ApproversSection from "components/StaffRequests/DetailsStaffRequest/components/ApproversSection";
import { useParams } from "react-router";
import dataProvider from "server/dataProvider";
import { employeeRequests } from "api/employeeApi";
import { useNotifyError } from "utils/useNotifyError";
import { StaffRequestTypes } from "utils/constants";

const EditVacation = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const [defaultValues, setDefaultValues] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const { id: leaveId } = useParams();

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(employeeRequests.getLeaveById(leaveId), null, "GET");
      setDefaultValues(data);
    } catch (err) {
      console.error(err);
      notify("Грешка при зареждане на данни. Опитайте да презаредите страницата.", { type: "error" });
    }
  }, [leaveId, notify]);

  const handleSubmit = async data => {
    try {
      const { documents, ...mainData } = data;
      await dataProvider.customRequest(employeeRequests.updateLeave(leaveId), mainData, "PUT");

      const updatedDocs = documents?.filter(doc => doc.document instanceof File) ?? [];
      for (const doc of updatedDocs) {
        await dataProvider.customRequest(
          employeeRequests.uploadLeaveDocument(leaveId),
          {
            document: { rawFile: doc.document },
            id: leaveId,
            description: doc.description ?? "",
          },
          "POST",
          null,
          true
        );
      }

      notify("Успешно редактирахте отпуск !", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notifyError(err);
    }
  };

  useEffect(() => {
    if (leaveId) {
      fetchDefaultValues()
    }
  }, [leaveId, fetchDefaultValues]);

  return (
    <>
      <Title title={`Редактиране на отпуск`} />
      <BackButtonToolbar />
      <ResourceContextProvider value={employeeRequests.getLeaveById(leaveId)}>
        {defaultValues && (
          <>
            <SimpleForm
              defaultValues={defaultValues}
              onSubmit={handleSubmit}
              toolbar={false}
            >
              <VacationRequest
                showPreview={showPreview}
                setShowPreview={setShowPreview}
                isCreate={false}
                onEditConfirm={handleSubmit}
                onDocumentDelete={fetchDefaultValues}
              />
            </SimpleForm>
            {!showPreview && (
              // The form only has defaultValues, so the table needs the leave as its record.
              <RecordContextProvider value={defaultValues}>
                <ApproversSection
                  type={StaffRequestTypes.AnnualLeave}
                  showActions={false}
                />
              </RecordContextProvider>
            )}
          </>
        )}
      </ResourceContextProvider>
    </>
  );
};

export default EditVacation;
